import { actionTypes } from './actions';
import { initialState } from './initial';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };

    case actionTypes.SET_SAVED_BONUS_SETTINGS:
      return {
        ...state,
        savedBonusSettings: action.payload,
      };

    case actionTypes.CLEAR_SAVED_BONUS_SETTINGS:
      return {
        ...state,
        savedBonusSettings: initialState.savedBonusSettings,
      };

    default:
      return state;
  }
}
